import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { _cs } from '@togglecorp/fujs';
import { IoChevronUp, IoChevronDown } from '../../node_modules/react-icons/io5/index.esm.js';
import Button from '../Button/index.js';
import { genericMemo } from '../../utils/index.js';
import Popup from '../Popup/index.js';
import useBooleanState from '../../hooks/useBooleanState.js';
import useBlurEffect from '../../hooks/useBlurEffect.js';
import styles from './styles.css.js';

var _IoChevronUp, _IoChevronDown;
function useDropdownFeatures() {
  let persistent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  const buttonRef = React.useRef(null);
  const popupRef = React.useRef(null);
  const [showPopup,, setShowPopupFalse, setShowPopup, togglePopup] = useBooleanState(false);
  const handleBlur = React.useCallback((clickedOnElement, clickedOnParent) => {
    if (clickedOnParent) {
      return;
    }

    if (persistent && clickedOnElement) {
      return;
    }

    setShowPopupFalse();
  }, [persistent, setShowPopupFalse]);
  useBlurEffect(showPopup, handleBlur, popupRef, buttonRef);
  return {
    buttonRef,
    popupRef,
    showPopup,
    setShowPopup,
    handleButtonClick: togglePopup
  };
}

function DropdownMenu(props) {
  const {
    className,
    variant = 'general',
    children,
    label,
    actions,
    popupClassName,
    popupContentClassName,
    popupMatchesParentWidth,
    popupPlacementDirection,
    hideDropdownIcon,
    persistent = false,
    componentRef,
    ...buttonProps
  } = props;
  const {
    buttonRef,
    popupRef,
    showPopup,
    setShowPopup,
    handleButtonClick
  } = useDropdownFeatures(persistent);
  React.useEffect(() => {
    if (componentRef) {
      componentRef.current = {
        setShowPopup
      };
    }
  }, [componentRef, setShowPopup]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, _extends({}, buttonProps, {
    name: undefined,
    variant: variant,
    elementRef: buttonRef,
    className: _cs(styles.dropdownMenu, className),
    onClick: handleButtonClick,
    actions: /*#__PURE__*/React.createElement(React.Fragment, null, actions, !hideDropdownIcon && (showPopup ? _IoChevronUp || (_IoChevronUp = /*#__PURE__*/React.createElement(IoChevronUp, null)) : _IoChevronDown || (_IoChevronDown = /*#__PURE__*/React.createElement(IoChevronDown, null))))
  }), label), /*#__PURE__*/React.createElement(Popup, {
    elementRef: popupRef,
    parentRef: buttonRef,
    className: _cs(styles.popup, popupClassName),
    contentClassName: popupContentClassName,
    show: showPopup,
    freeWidth: !popupMatchesParentWidth,
    placementDirection: popupPlacementDirection
  }, children));
}

var index = genericMemo(DropdownMenu);

export { index as default, useDropdownFeatures };
//# sourceMappingURL=index.js.map
